import React, {ReactElement} from "react";
import {To} from "react-router-dom";
import { Icon } from '@iconify/react';
import {RoutesList} from "./RoutesList";
import roles from "./roles";




interface Navigation {
    name:String,
    Icon:ReactElement,
    to:To,
    role:string[]
}

const links: Navigation[] = [
    {
        name:"Dashboard",
        Icon:<Icon icon="ic:round-space-dashboard" rotate={1} hFlip={true} />,
        to:RoutesList.Dashboard.Path,
        role:[roles.user]
    },
    {
        name:"Analytics",
        Icon:<Icon icon="majesticons:analytics" />,
        to:RoutesList.Analytics.path,
        role:[roles.user]
    },
    {
        name:"My Devices",
        Icon:<Icon icon="fluent:device-meeting-room-32-filled" />,
        to:RoutesList.MyDevices.path,
        role:[roles.user]
    },
    {
        name:"Users",
        Icon:<Icon icon="fa-solid:users" />,
        to:RoutesList.UsersList.path,
        role:[roles.admin,roles.superAdmin]
    },
    {
        name:"Readings",
        Icon : <Icon icon="bxs:data" />,
        to:RoutesList.AllReadings.path,
        role:[roles.superAdmin]
    },
    {
        name:"Devices",
        Icon : <Icon icon="mdi:watch-variant" />,
        to:RoutesList.AllDevices.path,
        role:[roles.superAdmin]
    },
    {
        name:"Admins",
        Icon : <Icon icon="dashicons:admin-users" />,
        to:RoutesList.AdminsList.path,
        role:[roles.superAdmin]
    },
    {
        name:"Clients",
        Icon : <Icon icon="dashicons:admin-users" />,
        to:RoutesList.AllClients.path,
        role:[roles.supremeAdmin]
    }
];

export default links;